import { render, staticRenderFns } from "./employe-form.vue?vue&type=template&id=bd01ad10"
import script from "./employe-form.vue?vue&type=script&lang=js"
export * from "./employe-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports